import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import Search from '@material-ui/icons/Search';

const Container = styled.div`

`

const InputStyled = styled(Input)`
  color: white;
  padding: 6px 0;
`

class InputBar extends Component {
  updateInput = event => {
    const { onChange } = this.props;
    const value = event.target.value;

    if (onChange) {
      onChange(value);
    }
  }

  searchSend = () => {
    const { onSubmit, value } = this.props;

    if (onSubmit) {
      onSubmit(value);
    }
  }

  render() {
    const {
      onChange,
      onClick,
      value,
      ...other
    } = this.props;

    return (
      <Container {...other}>
        <InputStyled
          placeholder='Search...'
          value={value}
          fullWidth
          disableUnderline
          onChange={this.updateInput}
          endAdornment={
            <InputAdornment position="end">
              <IconButton onClick={this.searchSend}>
                <Search style={{color: 'white'}}/>
              </IconButton>
            </InputAdornment>
          }
        />
      </Container>
    )
  }
}

InputBar.propTypes = {
  onChange: PropTypes.func,
  onSubmit: PropTypes.func,
  value: PropTypes.string,
};

InputBar.defaultProps = {

};

export default InputBar;
